/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/util';


$(document).ready(() => {

  //Check to see if the window is top if not then display button
  $(window).scroll(function(){

    // Show button after 100px
    const showAfter = 200;
    if ($(this).scrollTop() > showAfter) {
      $('.btn-back-to-top').removeClass('d-none').fadeIn();
    } else {
      $('.btn-back-to-top').fadeOut().addClass('d-none');
    }
  });

  //Click event to scroll to top
  $('.btn-back-to-top').click(function(){
    $('html, body').animate({scrollTop : 0},800);
    return false;
  });

});
